import SvgIcon from '@mui/material/SvgIcon';

/** Claude-style sidebar collapse: rounded rect with a left-panel divider. */
const SidebarCollapseIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect
      x="4.5"
      y="5.5"
      width="15"
      height="13"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9.5 5.5v13"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export default SidebarCollapseIcon;
